import Cookies from 'js-cookie';
import { trapFocus } from './focus-trap';
import { Modal } from 'flowbite';

const cookie_name = 'STYXKEY_win_fav';
const base_url = $('#base-url').attr('data-url');

let favoriteTarget = null;

const modalToggle = document.getElementById('favorite-remove-warning');
const modal = new Modal(modalToggle);

export const Favorites = {
    initialize() {
        $.ajax({
            type: 'POST',
            url: base_url + '/wp-admin/admin-ajax.php?nocache=' + Date.now(),
            data: {
                action: 'favorite_get',
            },
            success: function (response) {
                if (response) {
                    window.my_favorites = response;
                    var count = 0;
                    $.each(window.my_favorites, function (i, fav) {
                        count = count + 1;
                        $('.property-heart[data-id=' + fav + ']').addClass(
                            'is-fav'
                        );
                    });
                    if (response.length == 0) {
                        count = '';
                    } else {
                        count = '(' + response.length + ')';
                    }
                    $('.favourites_count').text(count);
                    $('.header-favourite-icon').attr('aria-label', 'click here to see the favourited items ' + (count || 0));
                }
            },
            error: function () {},
        });
    },
    fixHeights() {
        if ($('.page-template-template-favorites').length > 0) {
            $('#page-content').css('minHeight', '0');
            var _h = window.innerHeight;
            var header_h = $('header.header').outerHeight();
            var footer_h = $('footer.footer').outerHeight();
            var new_min = _h - header_h;
            new_min = new_min - footer_h;

            $('#page-content').css('minHeight', new_min);
        }
    },
    toggleNoFavoritesMessage() {
        if ($('.favorites-list').children().length > 0) {
            $(".favorites-fee-disclaimer-text").show();
            $('.no-favorites').addClass('hidden').removeClass('flex');
        } else {
            $(".favorites-fee-disclaimer-text").hide();
            $('.no-favorites').addClass('flex').removeClass('hidden');
        }
    },
    updateIsFavClasses() {
        $('.property-heart').removeClass('is-fav');
        var count = 0;
        $.each(window.my_favorites, function (i, fav) {
            count = count + 1;
            $('.property-heart[data-id=' + fav + ']').addClass('is-fav');
        });

        if (count == 0) {
            count = '';
        } else {
            count = '(' + count + ')';
        }
        $('.favourites_count').text(count);
        $('.header-favourite-icon').attr('aria-label', 'click here to see the favourited items ' + (count || 0));
    },
    update(action, property_id) {
        Favorites.toggleNoFavoritesMessage();
        Favorites.updateIsFavClasses();

        $.ajax({
            type: 'POST',
            url: base_url + '/wp-admin/admin-ajax.php',
            data: {
                action: action,
                property_id: property_id,
            },
            success: function (response) {
                var data = JSON.parse(response);
                if (data) {
                    if (data.favorite_id) {
                        Cookies.set(cookie_name, data.favorite_id);
                    }
                    if (data.favorites) {
                        window.my_favorites = data.favorites;
                        Favorites.toggleNoFavoritesMessage();
                        Favorites.updateIsFavClasses();
                    }
                }
            },
            error: function () {},
        });
    },
    heartEvents() {
        // bind heart event
        $(document).on('click', '.property-heart', function () {
            var property_id = $(this).data('id');

            if ($(this).hasClass('is-fav')) {
                // update the id and open the modal
                $('#favorite-remove-warning').attr(
                    'data-property-id',
                    property_id
                );

                // toggleModal('favorite-remove-warning', true);
                trapFocus(modalToggle);
                modal.show();
                favoriteTarget = $(this);
            } else {
                window.my_favorites.push(property_id); // will get updated shortly by ajax response
                Favorites.update('favorite_add', property_id);
            }
            return false;
        });
    },
    modalEvents() {
        $('.remove-favorite')
            .off()
            .on('click', function () {
                var property_id = $('#favorite-remove-warning').attr(
                    'data-property-id'
                );

                var index = window.my_favorites.indexOf(property_id); // will get updated shortly by ajax response
                if (index !== -1) {
                    window.my_favorites.splice(index, 1);
                }
                Favorites.update('favorite_remove', property_id);

                if ($('.favorites-list').length > 0) {
                    $(
                        '.favorites-list .a-property[data-id=' +
                            property_id +
                            ']'
                    )
                        .parent()
                        .remove();
                    Favorites.toggleNoFavoritesMessage();
                }
                // toggleModal('favorite-remove-warning', false);
                modal.hide();
                favoriteTarget.focus();

                return false;
            });

        // no button in modal
        $('.keep-favorite').on('click', function () {
            // toggleModal('favorite-remove-warning', false);
            modal.hide();
            favoriteTarget.focus();
            return false;
        });

        // set focus on modal close button click
        $(document).on(
            'click',
            '#favorite-remove-warning [data-modal-toggle]',
            function (event) {
                // toggleModal('favorite-remove-warning', false);
                modal.hide();
                window.setTimeout(() => favoriteTarget.focus(), 100);
            }
        );

        $(document).keyup(function (e) {
            if (e.key === 'Escape') {
                if (
                    $('#favorite-remove-warning').length > 0 &&
                    $('#favorite-remove-warning').is(':visible')
                ) {
                    // toggleModal('favorite-remove-warning', false);
                    modal.hide();
                    favoriteTarget.focus();
                }
            }
        });
    },
    init() {
        Favorites.initialize();
        Favorites.fixHeights();

        Favorites.toggleNoFavoritesMessage();
        Favorites.updateIsFavClasses();
        Favorites.heartEvents();
        Favorites.modalEvents();

        $(window).on('load resize', Favorites.fixHeights);
    },
};
